module.exports = __webpack_public_path__ + "img/waiting-room.c317951f.jpg";